import { render, staticRenderFns } from "./AssistantFeedback.vue?vue&type=template&id=54c16e8a&scoped=true&"
import script from "./AssistantFeedback.vue?vue&type=script&lang=ts&"
export * from "./AssistantFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./AssistantFeedback.vue?vue&type=style&index=0&id=54c16e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c16e8a",
  null
  
)

export default component.exports